<template>    
 <Responsive :breakpoints="{
    small: el => el.width <= 480
  }">
    <div class="px-4 scrollable-container" slot-scope="el" @click.prevent.stop="$store.myActions.UI_SET_MEASURETOOL('NONE')">  
      <div style="overflow:auto;height:100%;">    
        <div style="width:calc(100% - 20px)">
          <template v-for="menuItemGroup in menuItemsGroups" >
            <v-layout py-2 row wrap align-content-start  :key="menuItemGroup.key">
              <v-flex class="px-2" :class="{sm12:el.is.small,sm6:!el.is.small}" xs12 v-for="menuitem in menuItemGroup.values" :key="menuitem.cmp">      
                  <v-btn color="primary" 
                         :input-value="tabCreated(menuitem.cmp)" 
                          class="menu-btn"  outline 
                          @click="$store.myActions.UI_NAVTO_DETAIL({uiid:simulation_uiid,cmp:menuitem.cmp,isleft,id:-1})">
                    <v-icon v-if="menuitem.icon" left v-html="menuitem.icon"></v-icon>                     
                    {{tryTranslate(menuitem.label)}}
                    <v-spacer />
                  </v-btn>            
              </v-flex>            
            </v-layout>  
            <v-divider :key="`hr_${menuItemGroup.key}`" />   
          </template>
      </div>
      </div>
    </div>
  </Responsive> 
</template>
<script lang="ts">

  import Vue from 'vue'
  import Component from 'vue-class-component'
  import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
  import { groupBy } from '@/utils/groupBy'  
  import {SIMULATIONS_DETAIL_TABS} from '@/models/ui/SimulationTabs'
  import { SecurityItemsKeys } from '@/enum/SecurityItems'
  import { SimulationMode } from '@/enum/SimulationMode'  
  import { MissionGlobalType } from '@/enum/MissionGlobalType'
  import { isAloDbMissionGlobalCoverage, isAloDbMissionGlobalFormation, isAloDbMissionGlobalSimulation } from '@/models/alodb/AloDbMissionGlobal'

  @Component({
    name: 'SimulationMenu', 
    props: {
      isleft:Boolean
    }
  })
  export default class SimulationMenu extends Vue {
    
  isleft!:boolean      

  get menuItemsGroups() {   
    return groupBy(SIMULATIONS_DETAIL_TABS.filter(s => s.securityKey != SecurityItemsKeys.HIDDEN && 
                                                        ( s.usedFor.length == 0 
                                                          || (s.usedFor.includes(MissionGlobalType.SIMULATION) && isAloDbMissionGlobalSimulation(this.missionGlobal)) 
                                                          || (s.usedFor.includes(MissionGlobalType.COVERAGE) && isAloDbMissionGlobalCoverage(this.missionGlobal)) 
                                                          || (s.usedFor.includes(MissionGlobalType.FORMATION) && isAloDbMissionGlobalFormation(this.missionGlobal)) 
                                                        )                                                  
                                                  )
                    ,m => m.group)  
  }
   
  get tabItems() {
    return this.isleft?this.simulationState.tabsleft.tabs:this.simulationState.tabsright.tabs
  }

  get missionGlobal() {        
    return this.$store.myGetters.modifiedAdmMissionGlobal
  }

  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }

  get simulation_uiid() {
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get simulationState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState         
 }
    
  tabCreated(cmp:any) {
    return this.tabItems.findIndex(it => it.cmp == cmp) > -1
  
  }
  tryTranslate(key:string) {        
    const transKey = `Pilot.MissionDetailMenu.${key}`
    const trad = this.$t(transKey)
    return transKey == trad?key:trad
  }
}      
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .menu-btn{
    width:100%;
    min-width:230px;
    border-radius: 8px;
  }
  hr {
    
    margin: 0.5em auto;
  }
  hr:last-child  {
    display:none;
  }
</style>
